module.exports = __webpack_public_path__ + "img/logo1.94acd65a.png";